import { render, staticRenderFns } from "./ReportedDurationBlock.vue?vue&type=template&id=46c64a8e&scoped=true&"
import script from "./ReportedDurationBlock.vue?vue&type=script&lang=js&"
export * from "./ReportedDurationBlock.vue?vue&type=script&lang=js&"
import style0 from "./ReportedDurationBlock.vue?vue&type=style&index=0&id=46c64a8e&prod&lang=css&"
import style1 from "./ReportedDurationBlock.vue?vue&type=style&index=1&id=46c64a8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c64a8e",
  null
  
)

export default component.exports